import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    return { id: decodedToken.subTenantId };
  }
  return null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const CoolingShelfApi = {
  // Create Cooling Shelf
  CreateCoolingShelf: (data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/cooling-shelf-lives`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Cooling Shelf
  ListCoolingShelf: (page, limit) => {
    return apiApp
      .get(
        `/cooling-shelf-lives?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Cooling Shelf
  DeleteCoolingShelf: (ShelfLifeID) => {
    return apiApp
      .delete(
        `/cooling-shelf-lives/${ShelfLifeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Cooling Shelf
  PutCoolingShelf: (ShelfLifeID, data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/cooling-shelf-lives/${ShelfLifeID}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Get single Cooling Shelf
  SingleCoolingProcess: (ShelfLifeID) => {
    return apiApp
      .get(
        `/cooling-shelf-lives/${ShelfLifeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default CoolingShelfApi;
